<template>
  <v-container grid-list-lg>
    <v-layout row wrap fill-height>
      <v-flex d-flex xs12 sm12 md12>
       <v-card color="#0075bc" dark>
         <v-card-title primary class="title">IPP Demos</v-card-title>
         <v-card-text>{{ lorem }}</v-card-text>
       </v-card>
     </v-flex>
     <v-flex d-flex offset-sm4 xs4 sm4 md4>
       <v-layout row wrap justify-center>
         <v-flex d-flex  xs8 sm8 md8 >
           <v-btn @click='gotoBackgroundRiskModeling' class='text'>Click here to start</v-btn>
         </v-flex>
       </v-layout>
     </v-flex>
     <!-- <v-flex d-flex xs4 sm4 md4>
       <v-layout row wrap justify-center>
         <v-flex d-flex  xs8 sm8 md8>
             <v-btn @click='gotoExecDemo' class='text'>Input Variance Tester</v-btn>
         </v-flex>
       </v-layout>
     </v-flex>
     <v-flex d-flex xs4 sm4 md4>
       <v-layout row wrap justify-center>
         <v-flex d-flex  xs8 sm8 md8 >
           <v-btn @click='gotoTestcases' class='text'>IPP Test Cases</v-btn>
         </v-flex>
       </v-layout>
     </v-flex> -->

    </v-layout>
  </v-container>
</template>
<script>

  export default {
    data: () => ({
      lorem: ''
    }),
    created: function(){
    },
    mounted: function() {
        this.$store.commit('setCurrentPatientIndex', -1)
    },
    components:{
    },
    watch:{
    },
    computed: {
    },

    methods: {
      gotoExecDemo () {
        this.$router.push({'name':'demo4'})
      },
      gotoRankingDemo () {
        this.$router.push({'name':'main'})
      },
      gotoBackgroundRiskModeling () {
        this.$router.push({'name':'demo2'})

      },
      gotoTestcases () {
        this.$router.push({'name':'demo3'})

      }
    }
  };
</script>
<style scoped>

</style>
